import React, { useState, useEffect, useId } from "react";
import {  
  IressInput
} from "@iress/ids-components";

interface UsernameAndPasswordProps {
  username: string;
  onUsernameChanged: (username: string) => void;
  onPasswordChanged: (password: string) => void;
  disabled?: boolean;
}

export const UsernameAndPassword: React.FC<UsernameAndPasswordProps> = ({
  username: propUsername,
  onUsernameChanged,
  onPasswordChanged,
  disabled = false
}) => {
  const [localUsername, setLocalUsername] = useState<string>(propUsername);
  const [password, setPassword] = useState<string>("");
  
  const userIdId = useId();
  const passwordId = useId();

  // Update local username when prop changes, but only if it's different and not empty
  useEffect(() => {
    if (propUsername && propUsername !== localUsername) {
      setLocalUsername(propUsername);
    }
  }, [propUsername, localUsername]);

  // Event handler for when the user edits the username
  const handleUsernameChange = (e: any, value: string): void => {
    if (value !== localUsername) {
      setLocalUsername(value);
      onUsernameChanged(value);
    }
  };

  // Event handler for when the user edits the password
  const handlePasswordChange = (e: any, value: string): void => {
    if (value !== password) {
      setPassword(value);
      onPasswordChanged(value);
    }
  };

  return (
    /* Sign in panel */
    <div className="Section-header">
      <div className="subheading">O&amp;M Profiler Sign In</div>
      <IressInput
        className={disabled ? 'disabled' : 'username'}
        value={localUsername}
        onChange={handleUsernameChange}
        id={`userID-${userIdId}`}
        name="userID"
        placeholder="Please enter your O&M Profiler username (usually an email address)"
        required
      />
      <IressInput
        className={disabled ? 'disabled' : 'password'}
        value={password}
        onChange={handlePasswordChange}
        type="password"
        id={`password-${passwordId}`}
        placeholder="Please enter your O&M Profiler password"
      />
    </div>
  );
};
